<template>
  <div>
    <div class="igclub-container">
      <!-- https://www.youtube.com/embed/QX7Y0LiAo7o?autoplay=1&mute=1&enablejsapi=1&controls=0" -->
      <iframe src="https://player.vimeo.com/video/1002043465?autoplay=1&mute=0&loop=1&autopause=0" 
          frameborder="0" 
          allow="autoplay; encrypted-media" 
          width="100%" height="100%" 
          allowfullscreen
          title="IGClub">
      </iframe>
    </div>

    <div class="text-center mt-2">
      <PrimaryButton @click="handleClick" type="button">
        Saiba mais >>
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from '@/components/buttons/PrimaryButton'

export default {
  components: {
    PrimaryButton,
  },
  methods: {
    handleClick() {
        // window.open('https://api.whatsapp.com/message/SHGIUO65R2G7J1?autoload=1&app_absent=0');
        window.open('https://igclub.com.br')
    }
  }
}
</script>

<style scoped lang="scss">
.igclub-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70vh;
  min-width: 350px;
  
  iframe {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>